export default __webpack_public_path__ + "static/media/unpad.7a51f818.png";